global.loadedCssSelectors = {};

/**
 * Function to find a specific css selector in all the rules
 * @param  {Object}  rules       The different css rules
 * @param  {String}  cssSelector The css selector you're looking for
 * @return {Boolean}             Return true if the css selector has been found in the rules
 */
function isSelectorInRules(rules, cssSelector) {
    for (let i = 0; i < rules.length; i++) {
        if (rules[i].selectorText === cssSelector) {
            return true;
        }
    }

    return false;
}

/**
 * Function to return true if the css selector has been found in the different stylesheets
 * @param  {Object}  css         The different stylesheets
 * @param  {String}  cssSelector The css selector you're looking for
 * @return {Boolean}             Return true if the css selector has been found in the stylesheets
 */
function isSelectorInCss(css, cssSelector) {
    let rulesFound = false;
    try {
        rulesFound = css.cssRules && isSelectorInRules(css.cssRules, cssSelector);
    } catch (e) {
        return false;
    }
    return rulesFound;
}

/**
 * Function to dispatch a custom event when a specified class has been loaded
 * @param  {String} cssSelector The css selector you want to watch
 * @return {Event}              Return a new custom event
 */
export default function watchForLoadedCss(cssSelector) {
    let event = '';

    // IE10 polyfill
    if (typeof window.CustomEvent === 'function') {
        event = new CustomEvent(`css-rule-loaded-${cssSelector}`, { detail: 'CSS rule is loaded' });
    } else {
        event = document.createEvent('CustomEvent');
        event.initCustomEvent(`css-rule-loaded-${cssSelector}`, true, true, {
            detail: 'CSS rule is loaded',
        });
    }

    if (global.loadedCssSelectors[cssSelector]) {
        document.dispatchEvent(event);
    }

    for (let i = 0; i < document.styleSheets.length; i++) {
        if (isSelectorInCss(document.styleSheets[i], cssSelector)) {
            global.loadedCssSelectors[cssSelector] = true;
            document.dispatchEvent(event);
            return;
        }
    }

    setTimeout(() => watchForLoadedCss(cssSelector), 100);
}
